
webpack.register(
    'components/gallery-social-share/gallery-social-share',
    function() {
        return import('components/gallery-social-share/gallery-social-share');
    },
    true
);